/** @typedef {'none' | 'small' | 'medium' | 'large'} BrandBorderRadiusPreset */

export const BRAND_BORDER_RADIUS_OPTIONS = [
  { id: "none", label: "None", popup: 0, button: 0, input: 0 },
  { id: "small", label: "Small", popup: 10, button: 6, input: 6 },
  { id: "medium", label: "Medium", popup: 16, button: 10, input: 10 },
  { id: "large", label: "Large", popup: 24, button: 14, input: 12 },
];

export const DEFAULT_BRAND_BORDER_RADIUS = "medium";

const MIN_RADIUS_PX = 0;
const MAX_RADIUS_PX = 40;

/**
 * @param {string | number | null | undefined} value
 * @returns {number | null}
 */
export function parseBorderRadiusPx(value) {
  if (value == null || value === "") return null;
  if (typeof value === "number" && Number.isFinite(value)) {
    return Math.max(MIN_RADIUS_PX, Math.min(MAX_RADIUS_PX, value));
  }
  const match = String(value).trim().match(/^(\d+(?:\.\d+)?)/);
  if (!match) return null;
  const parsed = Number(match[1]);
  if (!Number.isFinite(parsed)) return null;
  return Math.max(MIN_RADIUS_PX, Math.min(MAX_RADIUS_PX, parsed));
}

/**
 * Resolve Brand & AI corner preset (none/small/medium/large) to px tokens.
 *
 * @param {string | null | undefined} preset
 * @returns {{ popup: number, button: number, input: number }}
 */
export function resolveBrandBorderRadiusPx(preset) {
  const id = BRAND_BORDER_RADIUS_OPTIONS.some((o) => o.id === preset)
    ? preset
    : DEFAULT_BRAND_BORDER_RADIUS;
  return (
    BRAND_BORDER_RADIUS_OPTIONS.find((o) => o.id === id) ||
    BRAND_BORDER_RADIUS_OPTIONS.find((o) => o.id === DEFAULT_BRAND_BORDER_RADIUS)
  );
}

/**
 * Parse numeric px or Brand & AI preset id into a single px value.
 *
 * @param {string | number | null | undefined} value
 * @param {'popup' | 'button' | 'input'} [role]
 * @returns {number | null}
 */
export function resolveBorderRadiusCandidatePx(value, role = "popup") {
  const numeric = parseBorderRadiusPx(value);
  if (numeric != null) return numeric;

  const preset = String(value || "").trim();
  if (!preset) return null;
  const resolved = resolveBrandBorderRadiusPx(preset);
  return resolved?.[role] ?? null;
}
